import { TypeRequest } from "../common/enums/AllEnums";
import { IAttribute } from "../interfaces/IAttribute";
import { IResponse } from "../interfaces/IResponse";
import { BisAPI, BisApiRequest } from "./apis";

export const GetAttributesByUserID = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerAtributosByUsuarioID?usuarioID=${userID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetAttributeByID = (attributeID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ObtenerAtributoByID?atributoID=${attributeID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}


export const DeactivateAttributeByID = (attributeID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {

        BisApiRequest(`/Proyecto/DesactivarAtributo?atributoID=${attributeID}`, TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const UpdateAttribute = (attribute: IAttribute): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/ActualizarAtributo`, TypeRequest.put, attribute).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertAttribute = (attribute: IAttribute): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Proyecto/InsertarAtributo`, TypeRequest.post, attribute).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
